import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick-theme.css";
import "react-image-gallery/styles/css/image-gallery.css";
import "slick-carousel/slick/slick.css";
import MyRouts from "./Routers/routes";
import "toastr/build/toastr.min.css";
import "./App.css";
import "./App.scss";
import { store } from "store";
import { Provider } from "react-redux";
import { Helmet } from "react-helmet";
function App() {
  return (
    <>
      <div className="App desktopUser">
        <Helmet>
          <title>{"Terpnash making physical art fair and digital"}</title>
          <meta property="image" content="" />
          <meta property="description" content="" /> 
        </Helmet>
          <Provider store={store}>
            <MyRouts />
          </Provider>
      </div>
      <div class="landscapeView">
        <img src="/images/png/rotateScreen.png" alt="" />
        <h3>Rotate Your Screen</h3>
      </div>
      <div class="foldMobile">
        <img src="/images/png/notsupport.png" alt="" />
        <h3>Portal not support <br />in this device</h3>
      </div>
    </>
  );
}
export default App;